"use client";

import type { FC, Ref } from "react";
import { BasicCard, Flex, Spacing, Text } from "@huub-web/ui";

import {
  SearchPropertySelect,
  type SearchPropertySelectProps,
} from "../SearchPropertySelect/SearchPropertySelect";
import type { WalterLivingAddress } from "../../services";

export type HouseSearchCardProps = {
  // debounceDelay?: number;
  // error?: boolean;
  // result?: ReactNode;
  // loading?: boolean;
  placeholder?: string;
  clearOnSelect?: boolean;
  onSearch?: (query: string) => void;
  onSearchStart?: (query: string) => void;
  getSearchResults: SearchPropertySelectProps["getSearchResults"];
  onPropertySelect?: (address: WalterLivingAddress | null) => void;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

export const HouseSearchCard: FC<HouseSearchCardProps> = ({
  // loading = false,
  // debounceDelay = 500,
  // result,
  clearOnSelect = true,
  onSearch,
  onSearchStart,
  getSearchResults,
  onPropertySelect,
  ref,
  ...props
}) => {
  const handlePropertySearch = (query: string) => {
    onSearch?.(query);
  };

  const handlePropertySearchStart = (query: string) => {
    onSearchStart?.(query);
  };

  const handlePropertySelect = async (address: WalterLivingAddress | null) => {
    if (!address) {
      return;
    }

    onPropertySelect?.(address);
  };

  return (
    <Flex direction="column" gap="m">
      <BasicCard
        ref={ref}
        // overflowHidden
        // icon="houseSearch"
        elevated
        border="gradient"
        // indicatorVariant="tertiary"
        title="Woningzoeker"
        // leading={
        // loading && <ProgressBar position="absolute" variant="infinite" />
        // }
        {...props}
      >
        <Text>
          Vul het adres van de woning die je hebt gevonden in. Huub doet de
          rest.
        </Text>
        <Spacing />

        <SearchPropertySelect
          onSearchStart={handlePropertySearchStart}
          onSearch={handlePropertySearch}
          onChange={handlePropertySelect}
          getSearchResults={getSearchResults}
          clearOnSelect={clearOnSelect}
          noResultsText="Staat jouw droomhuis er niet tussen? Plan een afspraak in met een van onze experts."
          width="stretch"
          // cta={searchCTA}
        />

        {/* <TextField
            leading={<Icon icon="search" size="s" color="placeholder" />}
            onChange={(value) => handleChange(value)}
            onFocus={() => handleFocus()}
            value={query}
            placeholder={placeholder}
            trailing={
              <IconButton
                ref={closeButtonRef}
                icon="close"
                size="xxs"
                rounded
                onClick={handleClear}
              />
            }
          /> */}
      </BasicCard>

      {/* <Reveal>
          {(loading || !!result || error) && (
            <Flex direction="column" gap="m">
              <Heading title="Zoekresultaten" />

              <Flex ref={resultRef} direction="column" gap="m">
                {error && !loading && (
                  <Message
                    variant="error"
                    body="Er is een fout opgetreden bij het zoeken naar woningen. Probeer het later nog eens."
                  />
                )}

                {loading ? <Placeholder /> : result ? result : null}
              </Flex>
            </Flex>
          )}
        </Reveal> */}

      {/* <Spacing /> */}
    </Flex>
  );
};
